
import React, { useState, useEffect } from 'react';
import { Navigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  User, 
} from "@models";

import DandDAPI from "@dndUtilities/system_api";

import LoadingBox from "@components/input/LoadingBox";
import StringBox from "@components/input/strings/StringBox";
import CheckBox from "@components/input/CheckBox";

const api = DandDAPI.getInstance();
// const common_util = DataUtilities.getInstance();

export default function UserEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<User>(new User());
  const [ping, setPing] = useState(false);
  
  const disabled = api.user === null || !api.online || (!api.user.is_admin && obj._id !== "" && obj._id !== api.user._id);

  // This is a better way for loading, without using the 'fetched' method.
  useEffect(() => {
    const load = async () => {
      if (id && id !== "") {
        setLoading(true);
        const res = await api.getFullObject<User>("user", id);
        if (res) {
          setObj(res);
          setPing(prev => !prev);
        }
        setLoading(false);
      }
    };
    
    load();
  }, [id]); // Only re-run when id changes

  const submit = async () => {
    if (api.user && 
      (api.user.is_admin || 
        obj._id === "" || 
        obj._id === api.user._id)) {
      setProcessing(true);
      const new_obj = obj.clone();
      await api.upsertObject("user", new_obj);
      if (api.user._id === new_obj._id) {
        if (api.spoofing) {
          api.user = new_obj;
        } else {
          api.true_user = new_obj;
        }
        api.subscription_holder.reload();
      }
      setProcessing(false);
      setNavigateTo("/user");
    }
  }

  const reload = async () => {
    // debugger;
    if (api.user) {
      setProcessing(true);
      const res = await api.getFullObject<User>("user", api.user._id);
      if (res) {
        setObj(res);
        if (api.spoofing) {
          api.user = res;
        } else {
          api.true_user = res;
        }
        api.subscription_holder.reload();
        setLoading(false);
      }
      setProcessing(false);
    }
  }

  const height = window.innerHeight - 105;
  if (loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else { 
    // const formHeight = window.innerHeight - (window.innerWidth > 600 ? 220 : 220);
    return (
      <div style={{ height }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              name="Username"
              value={obj.profile_name} 
              message={obj.profile_name.length > 0 ? "" : "Name Invalid"}
              onBlur={(changed: string) => {
                const new_obj = obj.clone();
                new_obj.profile_name = changed;
                setObj(new_obj);
                setPing(!ping);
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              name="Email"
              value={obj.email} 
              onBlur={(changed: string) => {
                const new_obj = obj.clone();
                new_obj.email = changed;
                setObj(new_obj);  
                setPing(!ping);
              }}
            />
          </Grid>
          { api.user && api.user.is_admin &&
            <Grid
              size={{
                xs: 12
              }}>
              <CheckBox 
                name="View Blocked Source Books"
                value={obj.view_blocked_source_books} 
                onChange={(value: boolean) => {
                  const new_obj = obj.clone();
                  new_obj.view_blocked_source_books = value;
                  setObj(new_obj);
                  setPing(!ping);
                }} 
              />
            </Grid>
          }
          { !disabled &&
            <Grid
              size={{
                xs: 12
              }}>
              <Button
                variant="contained"
                color="primary"
                disabled={processing}
                onClick={submit}>
                Submit
              </Button>
              <Button
                variant="contained"
                disabled={processing}
                style={{ marginLeft: "4px" }}
                onClick={ () => { 
                  setNavigateTo(`/user`);
                }}>
                Cancel
              </Button>
              { api.user && api.user._id === obj._id &&
                <Button
                  variant="contained"
                  color="primary"
                  disabled={processing}
                  style={{ marginLeft: "4px" }}
                  onClick={reload}>
                  Reload Your User
                </Button>
              }
            </Grid>
          }
        </Grid>
      </div>
    ); 
  }
}
